import { SaveType } from '../../../@types/types'
import { DispatchType } from '../../../@types/redux-types'
import { getValidationInvalid } from '../../../services/validation/validationService'
import { ValidationSchema } from '../../../@types/validation-types'
import { doSave } from './doSave'
import { InitState } from '../../reducers/root/initialState'
import { runValidation } from '../../../services/validation/editor/runValidation'

const WAIT_TIMEOUT = 1000
let autoSaveTimeout: ReturnType<typeof setTimeout>

export const doAutoSave =
  (validationSchema: ValidationSchema) => (dispatch: DispatchType, getState: () => InitState) => {
    clearTimeout(autoSaveTimeout)
    autoSaveTimeout = setTimeout(async () => {
      const insertionData = getState().insertionFeature.insertionData
      const addressFeature = getState().addressFeature
      const customValidationResults = getState().insertionFeature.customValidationResults
      const validationResult = runValidation(insertionData, addressFeature, validationSchema)
      const isValidationInvalid = getValidationInvalid(validationResult, (value) => value.fields)

      const isCustomValidationInvalid =
        customValidationResults && getValidationInvalid(customValidationResults, (value) => value.fields)

      // get fresh save state from store
      const isValid =
        !isValidationInvalid && !isCustomValidationInvalid && getState().insertionFeature.save !== SaveType.SAVING
      isValid && (await doSave(insertionData, false)(dispatch, getState))
    }, WAIT_TIMEOUT)
  }
